var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 260,
    viewBox: "0 0 57 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3573 206.709L51.9095 246.616L4.27911 246.301L28.3573 206.709Z",
    fill: "#FA3966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7772 138.715L51.6941 178.99L4.07473 177.92L28.7772 138.715Z",
    fill: "#FA3966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.762 68.7148L51.7021 108.976L4.08214 107.934L28.762 68.7148Z",
    fill: "#FA3966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8735 0.717432L51.644 41.0752L4.02884 39.8326L28.8735 0.717432Z",
    fill: "#FA3966"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.167935cbac621d5b4affa5251b9accfb.svg";
export { ForwardRef as ReactComponent };